module.exports = __webpack_public_path__ + "img/gotomeeting.a20a7688.png";